// core version + navigation, pagination modules:
import Swiper, { Pagination, Autoplay } from "swiper";

export function heroSlider() {
    Swiper.use([Pagination, Autoplay]);
    // init Swiper:
    const heroSlider = new Swiper(".hero-swiper", {
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}
